import React from 'react';
import './Home.css';

import { Link } from 'react-router-dom';

import Banner1 from '../../assets/images/Banner1.jpg';
import Banner2 from '../../assets/images/Banner2.jpg';
import Banner3 from '../../assets/images/Banner3.jpg';
import Banner4 from '../../assets/images/Banner4.jpg';
import Banner5 from '../../assets/images/Banner5.jpg';

import Aboutusbg from '../../assets/images/aboutusbg.jpg';
import Aboutushome from '../../assets/images/aboutushome.jpg';


function Home() {
  return (
    <>

      <section className='BannerSection'>
        <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
          <div class="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="2" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="3" aria-label="Slide 4"></button>
            <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="4" aria-label="Slide 5"></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">

              <div className='carousel-itemImg'>
                <img src={Banner1} alt="..." />
                <div className="carousel-itemtxt"><h4>Development of<br />Industrial Estates</h4></div>
              </div>

            </div>
            <div className="carousel-item">
              <div className='carousel-itemImg'>
                 <img src={Banner2} alt="..." />
              <div className="carousel-itemtxt"><h4>Supply of <br /> Quality Liquor Previous</h4></div>
              </div>
             

            </div>
            <div className="carousel-item">
              <div className='carousel-itemImg'>
                <img src={Banner3} alt="..." />
              <div className="carousel-itemtxt"><h4>Housing for <br /> EWS</h4></div>
              </div>
              
            </div>
            <div className="carousel-item">
              <div className='carousel-itemImg'>
                        <img src={Banner4} alt="..." />
              <div className="carousel-itemtxt"><h4>Infrastructure <br /> Development</h4></div>
              </div>
      


            </div>
            <div className="carousel-item">
              <div className='carousel-itemImg'>
                <img src={Banner5} alt="..." />
              <div className="carousel-itemtxt"><h4>Scrap Disposal <br /> Management (Sugamta)</h4></div>
              </div>
              


            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"><i class="fas fa-angle-left"></i></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"><i class="fas fa-angle-right"></i></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </section>

      <section className='AboutUsSection'>
        <div className='AboutUsSectionBg' style={{ backgroundImage: `url(${Aboutusbg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-8 col-sm-8 col-xs-12'>
              <h2>ABOUT US</h2>
              <h4>Omnibus Industrial Development Corporation of Daman & Diu and Dadra & Nagar Haveli Limited, (OIDC Ltd).</h4>
              <p>A Government Undertaking was incorporated on 27th March 1992 under the Company’s Act 1956. OIDC Ltd has emerged as a truly Omnibus Corporation performing multifarious functions. The Corporation has the mandate to promote industrial investment, technological upgradation, occupational training, and skill development, as well as expand export-oriented industries within its jurisdictional area.</p>
              <Link className="ReadMoreBtn" to='/aboutus'>Read More...</Link>
            </div>

            <div className='col-md-4 col-sm-4 col-xs-12'>
              <img className='AlcohalCircleImg' src={Aboutushome} alt="" />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home